export const isArrayMask = (constructor: any) =>
  constructor && constructor.name === 'ArrayMask'

export default isArrayMask
